import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React, { useEffect, useState } from "react";
import { listTableCols } from "./listTableCols";
import { lightTable } from "../../../../../../../../styles/muiProps";
import { Box, Button } from "@mui/material";

import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { useECSContext } from "../../ecsContext";

export default function ListTable() {
  const {
    ecsList,
    setEcsList,
    setSelectedListRow,
    tagMaterials,
    rowSelection,
    setRowSelection,
  } = useECSContext();

  useEffect(() => {
    const selectedListRowId = Object.keys(rowSelection)[0];

    selectedListRowId && setSelectedListRow(ecsList[selectedListRowId]);
  }, [rowSelection]);

  const handleTagNumberChange = (rowId, updates) => {
    console.log(rowId, updates);
    setEcsList((prev) =>
      prev.map((row) => (row.id === rowId ? { ...row, ...updates } : row)),
    );
  };

  const table = useMaterialReactTable({
    data: ecsList,
    columns: listTableCols(tagMaterials, handleTagNumberChange),

    ...lightTable,
    enableEditing: true,
    editDisplayMode: "row",
    createDisplayMode: "row",

    // ✅ GLOBAL DEFAULT FOR ALL EDIT CELLS
    muiEditTextFieldProps: {
      variant: "standard",
      size: "small",
      fullWidth: true,
    },

    // 👉 Save new row
    onCreatingRowSave: ({ values, table }) => {
      setEcsList((prev) => [...prev, values]);
      table.setCreatingRow(null); // exit create mode
    },

    // 👉 Cancel create
    onCreatingRowCancel: () => {
      console.log("Create cancelled");
    },

    enableRowSelection: true,
    enableMultiRowSelection: false,

    state: {
      rowSelection,
    },
    onRowSelectionChange: (updater) => {
      const newSelection =
        typeof updater === "function" ? updater(rowSelection) : updater;

      setRowSelection(newSelection);

      // ✅ Extract selected row
      const selectedListRowId = Object.keys(newSelection)[0];

      const row =
        selectedListRowId != null
          ? ecsList.find((r) => r.id === selectedListRowId)
          : null;

      setSelectedListRow(row);
    },

    getRowId: (row) => row.id,

    onRowSelectionChange: setRowSelection,
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "400px" } },

    displayColumnDefOptions: {
      "mrt-row-actions": {
        size: 20, // 👈 width in px
        minSize: 20,
        maxSize: 20,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    },
  });

  const onDeleteEscList = () => {
    setEcsList([]);
  };

  return (
    <Box>
      <Box
        sx={{
          p: 1,
          fontSize: 18,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Equipment List Dashboard
        <Box display="flex" gap={1}>
          <Button
            onClick={() => table.setCreatingRow(true)}
            variant="contained"
            startIcon={<AddBoxIcon />}
          >
            Add
          </Button>
          {/* <Button variant="contained" startIcon={<AddCircleOutlineIcon />}>
            Insert
          </Button> */}
          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            color="error"
            onClick={onDeleteEscList}
          >
            Delete
          </Button>
        </Box>
      </Box>
      <div style={{ marginTop: "5px" }}>
        <MaterialReactTable table={table} />
      </div>
    </Box>
  );
}
